import { useCallback, useState } from "react";

type UseLocalStorageResponse<T> = {
  value: T;
  setValue: (newValue: T) => void;
};

const useLocalStorage = <T>(
  storageKey: string,
  fallbackState: T
): UseLocalStorageResponse<T> => {
  const [value, setValueInternal] = useState<T>(() => {
    try {
      const item = localStorage.getItem(storageKey);
      return item !== null ? JSON.parse(item) : fallbackState;
    } catch {
      return fallbackState;
    }
  });

  const setValue = useCallback(
    (newValue: T) => {
      localStorage.setItem(storageKey, JSON.stringify(newValue));
      setValueInternal(newValue);
    },
    [storageKey]
  );

  return { value, setValue };
};

export default useLocalStorage;
